module.exports = __webpack_public_path__ + "img/luqi.58fd3a1a.png";